import { createSlice } from '@reduxjs/toolkit';

export const globalChatSlice = createSlice({
  name: 'globalChat',
  initialState: {
    chatSID: '',
    messages: [],
    newMsgCount: false,
  },
  reducers: {
    updateMessages: (state, action) => {
      const { newComment, name, identity, newMsgCount } = action.payload;
      return {
        ...state,
        newMsgCount: newMsgCount,
        messages: [
          ...state.messages,
          { comment: newComment, name: name, identity: identity },
        ],
      };
    },
    clearGlobalNewMsgCount: (state) => {
      return { ...state, newMsgCount: false };
    },
    clearMessages: (state) => {
      return {
        ...state,
        chatSID: '',
        messages: [],
        newMsgCount: false,
      };
    },
  },
});

export const { updateMessages, clearMessages, clearGlobalNewMsgCount } =
  globalChatSlice.actions;

export default globalChatSlice.reducer;
